var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { useBackend } from "../../layouts";
import { Empty } from "../Empty";
import { ArrowPathIcon, BoltSlashIcon, CheckCircleIcon, EnvelopeIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import React from "react";
import { Title, Text } from "../../tremor/Text";
import { Icon } from "../../tremor/Icon";
import { useAutomationsModal } from "./useAutomationsModal";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Button } from "../../tremor/Button";
import { CalendarIcon, LinkIcon } from "@heroicons/react/24/outline";
import { toast } from "sonner";
import { Badge } from "../../tremor/Badge";
import { getSchedule, stringToArray } from "cron-converter";
import { Tooltip } from "../../tremor/Tooltip";
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
export const AutomationHistory = ({}) => {
    const { selectedAutomation } = useAutomationsModal();
    const { backend } = useBackend();
    const [loading, setLoading] = useState(false);
    const [automationRuns, setAutomationRuns] = useState([]);
    useEffect(() => {
        if (!selectedAutomation)
            return;
        getAutomationRuns(selectedAutomation.id);
    }, [selectedAutomation]);
    const getAutomationRuns = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (!backend || !id)
            return;
        const runs = yield backend.automation(id).getRuns();
        setAutomationRuns(runs || []);
    });
    const testAutomation = () => {
        const id = selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.id;
        if (!backend || !id)
            return;
        if (!selectedAutomation)
            return;
        setLoading(true);
        const arr = stringToArray(selectedAutomation.schedule);
        let sch = getSchedule(arr, new Date(), selectedAutomation.timezone);
        let next_run_at = sch.next().toISO();
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            yield backend.automations.update(selectedAutomation.id, Object.assign(Object.assign({}, selectedAutomation), { next_run_at: next_run_at }));
            return backend === null || backend === void 0 ? void 0 : backend.automation(id).test();
        }), {
            loading: "Running automation...",
            success: () => {
                setLoading(false);
                getAutomationRuns(id);
                return "Automation ran successfully!";
            },
            error: (err) => {
                setLoading(false);
                return "Failed to run automation: " + err.message;
            }
        });
    };
    return (React.createElement("div", { className: "onvo-foreground-color onvo-h-full onvo-flex onvo-flex-col !onvo-p-0 onvo-mb-8" },
        React.createElement("div", { className: "onvo-px-4 onvo-background-color onvo-flex-shrink-0 onvo-py-2 onvo-border-solid onvo-border-b onvo-border-black/10 dark:onvo-border-white/10 onvo-flex onvo-flex-row onvo-items-center onvo-justify-center onvo-gap-3" },
            React.createElement("div", { className: "onvo-max-w-screen-md onvo-mx-auto onvo-flex onvo-items-center onvo-justify-between onvo-flex-row onvo-w-full" },
                React.createElement(Icon, { variant: "shadow", size: "sm", icon: CalendarIcon }),
                React.createElement(Title, { className: "onvo-text-sm onvo-ml-2 onvo-flex-grow" }, "Automation history"),
                React.createElement(Button, { isLoading: loading, onClick: testAutomation }, "Test automation"))),
        React.createElement("div", { className: "onvo-overflow-y-auto" },
            React.createElement("div", { className: "onvo-py-4 onvo-max-w-screen-md  onvo-mx-auto onvo-px-4" }, (automationRuns.length === 0 && !loading) ? (React.createElement(Empty, { title: "This automation has not been run yet.", direction: "column", subtitle: "You will be able to see the status of each automation run once it has been executed at least once", icon: React.createElement(BoltSlashIcon, { className: "onvo-size-8" }) })) : (React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-gap-2 onvo-mt-2" },
                loading && (React.createElement("div", { className: "onvo-border-solid onvo-border onvo-flex onvo-flex-row onvo-items-center onvo-gap-2 onvo-px-2 onvo-py-2 onvo-shadow-sm onvo-rounded-2xl dark:onvo-border-slate-700" },
                    React.createElement(ArrowPathIcon, { className: "onvo-size-5 onvo-text-blue-500 onvo-animate-spin" }),
                    React.createElement("div", { className: "onvo-flex-grow" },
                        React.createElement(Text, { className: "onvo-text-xs onvo-flex-shrink-0" }, "Testing automation...")))),
                automationRuns.map((a) => (React.createElement("div", { key: a.id, className: "onvo-border-solid onvo-border onvo-flex onvo-flex-row onvo-items-center onvo-gap-2 onvo-px-2 onvo-py-2 onvo-shadow-sm onvo-rounded-2xl dark:onvo-border-slate-700" },
                    a.status === "success" ? (React.createElement(CheckCircleIcon, { className: "onvo-size-5 onvo-text-green-500" })) : (React.createElement(ExclamationTriangleIcon, { className: "onvo-size-5 onvo-text-red-500" })),
                    React.createElement("div", { className: "onvo-flex-grow" },
                        React.createElement(Text, { className: "onvo-text-xs onvo-flex-shrink-0" },
                            a.status === "success" ? "Ran successfully " : "Run failed ",
                            `${dayjs(new Date(a.run_at)).fromNow()}`)),
                    a.status === "failure" && (React.createElement(Tooltip, { content: a.error },
                        React.createElement(Badge, { variant: "error", className: "!onvo-rounded-full" },
                            React.createElement(ExclamationTriangleIcon, { className: "onvo-size-4 onvo-text-red-500" }),
                            "Automation failed"))),
                    a.status === "success" && a.conditions_passed === false && (React.createElement(Tooltip, { content: a.error },
                        React.createElement(Badge, { variant: "warning", className: "!onvo-rounded-full" },
                            React.createElement(ExclamationTriangleIcon, { className: "onvo-size-4 onvo-text-yellow-500" }),
                            "Conditions failed"))),
                    a.status === "success" && a.conditions_passed === true && (React.createElement(Badge, { variant: "success", className: "!onvo-rounded-full" },
                        React.createElement(CheckCircleIcon, { className: "onvo-size-4 onvo-text-green-500" }),
                        "Conditions passed")),
                    a.status === "success" && a.recipient_emails && a.recipient_emails.length >= 0 && (React.createElement(Tooltip, { content: React.createElement("ul", null, (a.recipient_emails || []).map(email => (React.createElement("li", { key: email }, email)))) },
                        React.createElement(Badge, { className: "!onvo-rounded-full" },
                            React.createElement(EnvelopeIcon, { className: "onvo-size-4 onvo-text-blue-500" }),
                            (a.recipient_emails || []).length,
                            " emails sent"))),
                    a.status === "success" && a.webhook_sent === true && (React.createElement(Badge, { className: "!onvo-rounded-full" },
                        React.createElement(LinkIcon, { className: "onvo-size-4 onvo-text-blue-500" }),
                        "Webhook sent")))))))))));
};
//# sourceMappingURL=AutomationHistory.js.map